import { action } from 'typesafe-actions';

import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';

import { UserNotificationActionEnum } from '../enums/UserNotificationActionEnum';
import { INotificationWithPaginationResponse } from '../../../APIPackage/UserNotificationModule/interfaces/INotificationResponse';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { NotificationSearchTypeEnum } from '../enums/NotificationSearchTypeEnum';
import { INotificationReadStatusUpdateRequest } from '../../../APIPackage/UserNotificationModule/interfaces/INotificationReadStatusUpdateRequest';

export const userNotificationGetData = (searchType: NotificationSearchTypeEnum, searchValue?: string, page?: string) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_GET_DATA, { searchType, searchValue, page });

export const userNotificationSetData = (data: INotificationWithPaginationResponse) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_DATA, { data });

export const userNotificationUnreadGetCount = () =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_GET_UNREAD_COUNT);

export const userNotificationUnreadSetCount = (data: INotificationWithPaginationResponse) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_UNREAD_COUNT, { data });

export const userNotificationSetSelectOption = (data: ISelectOption) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_SELECT_OPTION, { data });

export const userNotificationSetPage = (page: number) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_PAGE, { page });

export const userNotificationSetSearchText = (text: string) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_SEARCH_TEXT, { text });

export const userNotificationResetInitialFormValues = () =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_RESET_INITIAL_FORM_VALUES);

export const userNotificationReadStatusUpdate = (request: INotificationReadStatusUpdateRequest) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_READ_STATUS_UPDATE, { request });

export const userNotificationGetFetchSettingByCode = (code: AdminSettingCodesEnum) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_GET_FETCH_SETTING_BY_CODE, { code });

export const userNotificationSetFetchSettingByCode = (settings: IAdminSetting) =>
  action(UserNotificationActionEnum.USER_NOTIFICATIONS_SET_FETCH_SETTING_BY_CODE, { settings });
